export default __webpack_public_path__ + "dca675e98bd852fa93a4879c3b8a44a6.png";